if (!customElements.get('newsletter-modal')) {
  customElements.define(
    'newsletter-modal',
    class NewsletterModal extends ModalElement {
      constructor() {
        super();
    
        // Prevent popup on Shopify robot challenge page
        if (window.location.pathname === '/challenge' || !theme.cookiesEnabled()) {
          return;
        }
    
        if (!theme.config.isTouch || Shopify.designMode) {
          this.init();
        }
        else {
          new theme.initWhenVisible(theme.utils.throttle(this.init.bind(this)));
        }
      }
    
      get shouldLock() {
        return true;
      }
    
      get testMode() {
        return this.getAttribute('data-test-mode') === 'true';
      }
    
      get delay() {
        return this.hasAttribute('data-delay') ? parseInt(this.getAttribute('data-delay')) : 5;
      }
    
      get expiry() {
        return this.hasAttribute('data-expiry') ? parseInt(this.getAttribute('data-expiry')) : 30;
      }
    
      get cookieName() {
        return 'concept:newsletter-popup';
      }
    
      get submited() {
        return this.querySelector('.alert') !== null;
      }
    
 init() {
  if (this.initialized) return;
  this.initialized = true;
  
  if (this.submited) {
    this.load(1);
    return;
  }

  var WEEKEND_START = new Date('2026-08-21T08:00:00Z');
  var WEEKEND_END   = new Date('2030-08-23T22:00:00Z');
  var isWeekendOffer = new Date() >= WEEKEND_START && new Date() <= WEEKEND_END;
  var alreadySubscribed = !!this.getCookie('concept:newsletter-subscribed');

  if (this.testMode || (isWeekendOffer && !alreadySubscribed) || !this.getCookie(this.cookieName)) {
    this.load(this.delay);
  }
}
    
      load(delay) {
        if (Shopify.designMode) return;
    
        setTimeout(() => this.show(), delay * 1000);
      }
    
      afterShow() {
        super.afterShow();
        this.classList.add('show-image');
      }
    
      afterHide() {
        super.afterHide();
        this.classList.remove('show-image');
    
        // Remove a cookie in case it was set in test mode
        if (this.testMode) {
          this.removeCookie(this.cookieName);
          return;
        }
    
        this.setCookie(this.cookieName, this.expiry);
      }
    
      getCookie(name) {
        const match = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
        return match ? match[2] : null;
      }
    
      setCookie(name, expiry) {
        document.cookie = `${name}=true; max-age=${(expiry * 24 * 60 * 60)}; path=/`;
      }
    
      removeCookie(name) {
        document.cookie = `${name}=; max-age=0`;
      }
    }
  );

 document.addEventListener('DOMContentLoaded', function () {
  var forms = document.querySelectorAll('.newsletter-form');

  forms.forEach(function (form) {
    var contextInput = form.querySelector('input[name="contact[context]"]');
    if (!contextInput || contextInput.value !== 'popup') return;

    var submitButton = form.querySelector('button[type="submit"]');
    if (!submitButton) return;

    submitButton.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();

      var emailInput = form.querySelector('input[name="contact[email]"]');
      var email = emailInput ? emailInput.value : '';

      if (!email) return;

      var formData = new FormData(form);

      fetch(form.action || window.location.pathname, {
        method: 'POST',
        body: formData,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function () {
          showSuccessMessage(form);
          addFreeGift();
        })
        .catch(function (err) {
          console.error('Erreur inscription newsletter:', err);
        });
    }, true); // phase de capture : s'exécute avant magnet-button
  });

  function showSuccessMessage(form) {
  var existingAlert = form.querySelector('.alert');
  if (existingAlert) existingAlert.remove();

  var WEEKEND_START = new Date('2026-08-21T08:00:00Z');
  var WEEKEND_END   = new Date('2030-08-23T22:00:00Z');
  var isWeekendOffer = new Date() >= WEEKEND_START && new Date() <= WEEKEND_END;

  var alert = document.createElement('div');
  alert.className = 'alert alert--success';
  alert.textContent = isWeekendOffer
    ? "VOS 2 TAIES OFFERTES S'AJOUTENT AUTOMATIQUEMENT DÈS QUE VOUS AJOUTEZ UNE PARURE EN SATIN DE COTON À VOTRE PANIER."
    : 'Merci ! Une serviette blanche offerte a été ajoutée à votre panier.';
  form.appendChild(alert);

  var field = form.querySelector('.field');
  if (field) field.style.display = 'none';
}

   function addFreeGift() {
    var WEEKEND_START = new Date('2026-08-21T08:00:00Z'); // vineri 21/08, 10:00 ora Frantei
    var WEEKEND_END   = new Date('2030-08-23T22:00:00Z'); // duminica 23/08, 24:00 ora Frantei
    var isWeekendOffer = new Date() >= WEEKEND_START && new Date() <= WEEKEND_END;

    if (isWeekendOffer) {
      // Oferta weekend: 2x taies satin assortite (gestionata de satin-gift-dynamic.js)
      document.cookie = 'concept:newsletter-subscribed=true; max-age=' + (30 * 24 * 60 * 60) + '; path=/';
      if (window.__satinGiftSync) window.__satinGiftSync();
      return;
    }

    // Oferta standard (serviette) - active en dehors du weekend
    var cookieName = 'concept:newsletter-gift-added';
    if (document.cookie.match(new RegExp('(^|;)\\s*' + cookieName + '\\s*=\\s*([^;]+)'))) return;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: 58539500405120, quantity: 1 }]
      })
    })
      .then(function (res) { return res.json(); })
      .then(function () {
        document.cookie = cookieName + '=true; max-age=' + (30 * 24 * 60 * 60) + '; path=/';

        document.dispatchEvent(new CustomEvent('cart:refresh', {
          detail: { open: true }
        }));
      })
            .catch(function (err) {
        console.error('Erreur ajout cadeau newsletter:', err);
      });
  }
});
}